import React, { useState } from "react";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Stack,
  Paper,
  Link,
  Divider,
} from "@mui/material";
import {
  CloudUpload,
  Link as LinkIcon,
  Language,
  BuildCircle,
  AutoAwesome,
  TipsAndUpdates,
} from "@mui/icons-material";
import Grid2 from "@mui/material/Grid2";   // v6
import { ReactComponent as UploadIcon } from "../../images/uploadIcon.svg";
import { ReactComponent as ImportSwaggerIcon } from "../../images/ImportSwaggerIcon.svg";
import { ReactComponent as APIDocUrlIcon } from "../../images/APIDocUrlIcon.svg"
import { ReactComponent as ManualConfigIcon } from "../../images/ManualConfigAPIIcon.svg";
import { ReactComponent as TipsIcon } from "../../images/APITipsIcon.svg";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useNavigate,useLocation } from "react-router-dom";
import { ReactComponent as MultisourceIcon } from "../../images/MultiSourceAPIIcon.svg";



function OptionCard({ icon, title, description, navigateTo, disabled, opacity }) {

  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    if (navigateTo) {
      navigate(navigateTo);
    }
  };

  return (
    <Card
      elevation={0}
      sx={{
        width: 350,
        height: 120,
        display: "flex",
        flexDirection: "column",
        borderRadius: 1,
        boxShadow: "none",
        opacity: opacity ? 0.5 : 1
      }}
    >
      <CardActionArea
        onClick={handleClick}
        disabled={disabled}
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          "&:hover": {
            backgroundColor: "#E1F5FF",
          },
        }}
      >
        <CardContent
          sx={{
            flexGrow: 1,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            p: 2,
            
          }}
        >
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="center"
            mb={1}
          >
            {icon}
            <Typography
              variant="subtitle1"
              sx={{
                wordBreak: "break-word",
                overflowWrap: "break-word",
                color: "#0094FB"
              }}
            >
              {title}
            </Typography>
          </Stack>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              wordBreak: "break-word",
              overflowWrap: "break-word",
            }}
          >
            {description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>


  );
}

function APINewLandingPage() {
  const [tab, setTab] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();


  const handleChange = (_, newValue) => {
    setTab(newValue);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#F6F3F2",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        py: 6,
        px: 2,
        maxWidth: "100%",
        width: "100%",
      }}
    >
      {/* Title */}
      <Typography variant="h4" gutterBottom>
        API Testing
      </Typography>
      <Box >

        <Typography variant="subtitle1" color="text" textAlign="center"
          sx={{
            maxWidth: {
              xs: "90%",
              sm: "85%",
              md: "85%",
              lg: "85%",
              xl: "85%",
            },
            mx: "auto",
            fontSize: "1rem",
          }}>
          Generate comprehensive test suites, detect edge cases and automate API testing.
        </Typography>
      </Box>

      <Divider sx={{ my: 2, width: "100%", maxWidth: "900px" }} />

      {/* Tabs */}
      <Box sx={{
        mt: 2, borderRadius: 3, bgcolor: "#ffff", p: "3px",
        display: "inline-flex",
        boxShadow: 1,
      }}>
        <Tabs
          value={tab}
          onChange={handleChange}
          TabIndicatorProps={{ style: { display: "none" } }} // remove underline
          sx={{
            minHeight: "36px",
            "& .MuiTab-root": {
              textTransform: "none",
              fontSize: "0.95rem",
              // fontWeight: 600,
              borderRadius: "8px",
              minHeight: "32px",
              px: 3,
              transition: "all 0.2s ease-in-out",
            },
            "& .Mui-selected": {
              bgcolor: "#0094FB",
              color: "#fff !important",
            },
            "& .MuiTab-root:not(.Mui-selected)": {
              bgcolor: "#fff",
              color: "text.primary",
              "&:hover": {
                bgcolor: "grey.100",
              },
            },
          }}
        >
          <Tab
            label="API Test Design"
          // sx={{ textTransform: "none", fontSize: "1rem", fontWeight: "600" }}
          />
          <Tab
            label="API Test Automation"
            onClick={() => navigate("/dashboard/api-testing/uploadapi")}
          // sx={{ textTransform: "none", fontSize: "1rem", fontWeight: "600" }}
          />
        </Tabs>
      </Box>

      {/* Tab Content */}
      <Box sx={{
        mt: 3,
        mx: "auto", // centers the Box itself horizontally
        display: "flex",
        justifyContent: "center",

      }}>
        {tab === 0 && (
          <Box sx={{ width: "100%" }}>
            {/* Row 1 */}
            <Grid2 container spacing={3} alignItems="stretch">
              <Grid2 xs={12} sm={6}>
                <OptionCard
                  icon={<UploadIcon />}
                  title="Upload API Specs"
                  description="Upload your API spec file to create test cases"
                  navigateTo="/dashboard/api-testing/uploadspecs"
                />
              </Grid2>
              <Grid2 xs={12} sm={6}>
                <OptionCard
                  icon={<ImportSwaggerIcon />}
                  title="Import from Swagger URL"
                  description="Import your Swagger URL to generate test cases"
                  navigateTo="/dashboard/api-testing/import-swagger"
                />
              </Grid2>

            </Grid2>

            {/* Row 2 */}
            <Grid2 container spacing={3} alignItems="stretch" sx={{ mt: 3 }}>
              <Grid2 xs={12} sm={6} >
                <OptionCard
                  icon={<Language htmlColor="#0094FB" />}
                  title="Analyse Live Website"
                  description="Enter a URL to analyze its API endpoints"
                  navigateTo="/dashboard/api-testing/analyse-website"
                  disabled={true}
                  opacity={true}

                 
                />
              </Grid2>
              <Grid2 xs={12} sm={6}>
                <OptionCard
                  icon={<ManualConfigIcon />}
                  title="Manual Configuration"
                  description="Enter endpoint details manually"
                  navigateTo="/dashboard/api-testing/manual-configuration"
                />
              </Grid2>
            </Grid2>

            {/* Row 3 */}
            {/* <Grid2 container spacing={3} sx={{ mt: 3, bgcolor: "red" }}> */}
            <Grid2 xs={12} sx={{ mt: 3 }} >
              <Card
                elevation={0}
                sx={{
                  height: 120,          // fixed height
                  width: "100%",        // fill the grid cell
                  display: "flex",
                  alignItems: "center", // center vertically
                  justifyContent: "center", // center horizontally
                  borderRadius: 1,
                  boxShadow: "none",
                  textAlign: "center",
                }}
              >
                <CardActionArea
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    "&:hover": {
                      backgroundColor: "#E1F5FF",

                    },
                  }}
                  onClick={() => navigate("/dashboard/api-testing/multi-source-combination")
                  }

                >
                  <CardContent sx={{
                    flexGrow: 1,
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                    p: 2,
                  }}>
                    <Stack direction="row" spacing={1} justifyContent="center" alignItems="center" mb={1}>
                      <MultisourceIcon />
                      <Typography variant="subtitle1"
                        sx={{
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                           color: "#0094FB"
                        }}

                      >Multi-Source combination</Typography>
                    </Stack>
                    <Typography variant="body2" color="text.secondary"
                      sx={{
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      Combine multiple API discovery methods to build a comprehensive test suite.</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid2>
            {/* </Grid2> */}

          </Box>
        )}
    
        {/* {tab === 1 && (
          <Box sx={{ width: "100%", }}>
            {/* Row 1 */}

            {/* Row 2 *
            <Grid2 container spacing={3} alignItems="stretch" sx={{ mt: 0.5 }}>
              <Grid2 xs={12} sm={6}>
                <OptionCard
                  icon={<UploadIcon />}
                  title="Upload Test Cases"
                  description="Upload an excel file with test cases"
                />
              </Grid2>
              <Grid2 xs={12} sm={6}>
                <OptionCard
                  icon={<ImportSwaggerIcon />}
                  title="Import from Jira"
                  description="Import test cases from Jira"
                />
              </Grid2>
            </Grid2>

            {/* Row 3 */}
            {/* <Grid2 container spacing={3} sx={{ mt: 3, bgcolor: "red" }}> 
            <Grid2 xs={12} sx={{ mt: 3 }} >
              <Card
                elevation={0}
                sx={{
                  height: 120,          // fixed height
                  width: "100%",        // fill the grid cell
                  display: "flex",
                  alignItems: "center", // center vertically
                  justifyContent: "center", // center horizontally
                  borderRadius: 1,
                  boxShadow: "none",
                  textAlign: "center",
                }}
              >
                <CardActionArea
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    "&:hover": {
                      backgroundColor: "#E1F5FF",
                    },
                  }}
                >
                  <CardContent sx={{
                    flexGrow: 1,
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                    p: 2,
                  }}>
                    <Stack direction="row" spacing={1} justifyContent="center" alignItems="center" mb={1}>
                      <ManualConfigIcon />
                      <Typography variant="subtitle1">Freeform Testing</Typography>
                    </Stack>
                    <Typography variant="body2" color="text.secondary">
                      Drag and drop your API definition file here or click to select
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid2>
            {/* </Grid2> 

          </Box>
        )} */}



      </Box>


      {/* Tip Section */}
      <Box
        elevation={0}
        sx={{
          mt: 5,
          borderRadius: 2,
          p: 2,
          maxWidth: "100%",
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <TipsIcon />
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="body2" color="text">
            <b>Here is a tip for you</b> </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.9rem" }}>
            Most teams start with AI Import for faster setup.
            You can always switch to manual configuration.
          </Typography>
        </Box>
      </Box>

      {/* Help Link */}
      <Link
        href="#"
        underline="true"
        sx={{
          mt: 3, fontSize: "0.9rem", color: "#0094FB",
          display: "inline-flex",
          alignItems: "center",
          gap: "3px",
        }}
      >
        Need Help
        <HelpOutlineIcon sx={{
          fontSize: "1rem",
          position: "relative",
          top: "2px",
        }} />
      </Link>
    </Box>
  );
}



export default APINewLandingPage;
